export const getWrapperStyles = ({ customStyles } = {}) => ({
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  borderRadius: 'none',
  padding: 0,
  ...customStyles,

  '&:hover': {
    backgroundColor: 'transparent',
  },

  '&:disabled': {
    opacity: 0.5,
  },
});
